import logo from "../assets/icons/logo.png";
import { useGetReceipt } from "../hooks/useGetReceipt";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { calculate } from "../apollo";
import {
  GetGoodQuery,
  GetReceiptInput,
  GetReceiptQuery,
  Good,
  GetGoodInput,
} from "../gql/graphql";
import { useGetGood } from "../hooks/useGetGood";
import { useMe } from "../hooks/useME";
export const PaymentCompleted = () => {
  const navigate = useNavigate();
  const params = useParams();
  //임시 코드
  const { state } = useLocation();
  const { data: me } = useMe();
  const goodId = Number(params?.receiptUuid);
  const [datas, setData] = useState<any>();
  const [amount, setAmount] = useState<number>(0);
  const onGetGoodCompelted = (data: any) => {
    console.log(data);
    if (data?.getGood.ok && data?.getGood.good) {
      setData(data?.getGood.good);
      let good = data?.getGood.good;
      let MountArray: any[] = [];
      if (Array.isArray(state)) {
        state.map((optionIndex: number) => {
          let goodOption = good.goodOptions[optionIndex];
          if (!goodOption.price) {
            goodOption.price = good.price;
          }
          MountArray.push(goodOption);
        });
      }
      setAmount(
        MountArray.reduce((acc: number, option: any) => acc + option.price, 0)
      );
    }
  };
  const [
    getGood,
    { loading: getGoodLoading, called: getGoodCalled, data: goodData },
  ] = useGetGood(onGetGoodCompelted);
  const goodHandler = () => {
    if (!getGoodLoading) {
      const input: GetGoodInput = {
        goodId,
      };
      getGood({ variables: { input } });
    }
  };
  useEffect(() => {
    if (me?.me.type === "Test") {
      goodHandler();
    }
  }, [me]);
  // 임시 코드 끝
  // get receipt
  const onGetReceipt = (data: GetReceiptQuery) => {
    const {
      getReceipt: { ok, err, receipt },
    } = data;
    if (ok) {
    }
  };
  const [
    getReceipt,
    { loading: getReceiptLoading, called: getReceiptCalled, data },
  ] = useGetReceipt(onGetReceipt);
  const getReceiptHandler = (receiptUuid: string) => {
    if (!getReceiptLoading) {
      const input: GetReceiptInput = {
        receiptUuid,
      };
      getReceipt({ variables: { input } });
    }
  };

  useEffect(() => {
    if (params) {
      const receiptUuid = params.receiptUuid
        ? params.receiptUuid.split("?")[0]
        : "";
      if (receiptUuid === "") alert("잘못된 접근입니다");
      getReceiptHandler(receiptUuid);
    }
  }, []);
  return (
    <div className="wrap max-w-screen-break mx-auto w-full h-full overflow-auto removeScroll">
      <main className="max-w-screen-break relative pt-24 pb-32">
        <img src={logo} alt="결제완료 닐리버리 로고" className="mx-auto px-8" />

        <div className="flex flex-col items-center justify-center text-mainIcon text-2xl font-bold pt-12">
          결제가 완료되었습니다.
        </div>
        <div className="pt-24">
          <p className="px-8 py-1 text-standard break:text-large text-darkFont  font-bold">
            주문상품
          </p>
          <div className="px-4 ">
            {datas && (
              <div className="pt-4">
                <div className="basketCard">
                  <div className="cardTop flex gap-x-2 w-full">
                    <div className="flex-1 flex">
                      <img
                        src={`${datas?.goodPosters[0]?.upload?.url}`}
                        alt="이미지"
                        className="w-[72px] h-[72px] rounded-lg border border-btnLightLine"
                      />
                      <div className="px-2 flex-1">
                        <div className="w-full py-1">
                          <p className="text-darkFont h-9 text-small break:text-standardall ellipsis2 overflow-hidden">{`${datas?.title}`}</p>
                        </div>
                        <div className="h-7 flex flex-wrap justify-between content-center">
                          <p className="text-small break:text-standardall text-hintFont flex gap-2">
                            {Array.isArray(state) &&
                              state.map((optionIndex: number) => (
                                <span key={`option-${optionIndex}`}>
                                  {`${datas?.goodOptions[optionIndex]?.name}`}
                                </span>
                              ))}
                          </p>
                          {Array.isArray(state) && (
                            <span className="text-darkFont font-bold text-small break:text-standardall">
                              {amount.toLocaleString()}원
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {!getReceiptLoading &&
              data?.getReceipt.ok &&
              data.getReceipt.receipt?.orders?.map((order, index) => (
                <div className="pt-4" key={`receipt-gets-item-${index}`}>
                  <div className="basketCard">
                    <div className="cardTop flex gap-x-2 w-full">
                      <div className="flex-1 flex">
                        <img
                          src={`${
                            order?.good?.goodPosters?.find(
                              (goodPoster) => goodPoster.index === 1
                            )?.upload?.url
                          }`}
                          alt="이미지"
                          className="w-[72px] h-[72px] rounded-lg border border-btnLightLine"
                        />
                        <div className="px-2 flex-1">
                          <div className="w-full py-1">
                            <p className="text-darkFont h-9 text-small break:text-standardall ellipsis2 overflow-hidden">{`${order?.good?.title}`}</p>
                          </div>
                          <div className="h-7 flex flex-wrap justify-between content-center">
                            <span className="text-small break:text-standardall text-hintFont">{`${order?.good?.title}`}</span>
                            {order?.good?.price && (
                              <span className="text-darkFont font-bold text-small break:text-standardall">
                                {(Number(order.amount)).toLocaleString()}
                                원
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
        {!getReceiptLoading && data?.getReceipt.ok && data.getReceipt.receipt && (
          <div className="px-8 pt-8">
            <div className="border-t border-btnLightLine pt-4 space-y-2">
              <div className="flex justify-between text-standard text-hintFont">
                <span>상품 금액</span>
                <span>
                  {(
                    data.getReceipt.receipt.orders?.reduce(
                      (sum, order) => sum + Number(order.amount || 0),
                      0
                    ) || 0
                  ).toLocaleString()}
                  원
                </span>
              </div>
              <div className="flex justify-between text-standard text-hintFont">
                <span>배송비</span>
                <span>
                  {(data.getReceipt.deliveryFee || 0).toLocaleString()}원
                </span>
              </div>
              <div className="flex justify-between text-standard break:text-large text-darkFont font-bold pt-2">
                <span>총 결제금액</span>
                <span>
                  {(
                    data.getReceipt.receipt.paid_amount ??
                    (data.getReceipt.receipt.orders?.reduce(
                      (sum, order) => sum + Number(order.amount || 0),
                      0
                    ) || 0) + (data.getReceipt.deliveryFee || 0)
                  ).toLocaleString()}
                  원
                </span>
              </div>
            </div>
          </div>
        )}
      </main>
      <div className="absolute left-0 bottom-0 w-full bg-white">
        <div className="py-4 px-8 w-full max-w-screen-fit mx-auto">
          <button
            onClick={() => {
              navigate("/");
            }}
            className="bg-mainIcon  block w-full max-w-screen-fit text-white text-xl font-bold h-[56px] mx-auto rounded-full"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
};
